import { FetcherOpts, FetcherParams, FetcherReturnType } from "@graphiql/toolkit";
import { opsApi } from "common/api";

export async function executeQuery(graphQLParams: FetcherParams, opts?: FetcherOpts): Promise<FetcherReturnType> {
    const result = await opsApi.graphQLQuery(graphQLParams.query, graphQLParams.variables);

    return result;
}